import {css} from "@emotion/react";

import {type Theme, styled} from "@atg-ui/toolkit/theme";
import {common} from "@atg-ui/toolkit/theme/colors";

import type {BorderProps} from "../../../types/image";

export const DEFAULT_BORDER: BorderProps = {
    xs: 2,
    sm: 4,
};

export const fixedBorder = (width: number): BorderProps => ({
    xs: width,
});

const image = css`
    width: 100%;
    position: relative;
`;

export const imageBorder = ({
    theme,
    color,
    xs = 2,
    sm,
    md,
    lg,
}: BorderProps & {theme: Theme}) => {
    const borderColor = color ?? common.white;
    return css`
        border: ${xs}px solid ${borderColor};

        ${sm &&
        css`
            ${theme.breakpoints.up("sm")} {
                border: ${sm}px solid ${borderColor};
            }
        `}

        ${md &&
        css`
            ${theme.breakpoints.up("md")} {
                border: ${md}px solid ${borderColor};
            }
        `}

    ${lg &&
        css`
            ${theme.breakpoints.up("lg")} {
                border: ${lg}px solid ${borderColor};
            }
        `}
    `;
};

export const imageRadius = ({
    rounded,
    borderRadius,
}: {
    borderRadius?: string;
    rounded?: boolean;
}) => {
    if (rounded) {
        return css`
            border-radius: 50%;
        `;
    }

    return css`
        border-radius: ${borderRadius ?? `0px`};
    `;
};

const fixedHeight = css`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    object-fit: cover;
`;

export const Img = styled("img")<{
    borderOptions?: BorderProps;
    rounded?: boolean;
    wrapped?: boolean;
}>(
    ({theme, borderOptions, rounded, wrapped}) => css`
        ${borderOptions && imageBorder({theme, ...borderOptions})};
        ${(rounded || borderOptions) &&
        imageRadius({rounded, borderRadius: borderOptions?.borderRadius})};
        ${image};
        ${wrapped && fixedHeight};
    `,
);

export default Img;
